// extracted by mini-css-extract-plugin
export default {"button":"styles_button__KKi5k","button_small":"styles_button_small__GK+sF","button_light":"styles_button_light__10qbY","button_up":"styles_button_up__5VLpp"};